import { useMutation } from '@tanstack/react-query'

import { WBDApi } from '@/open-api'
import type { UploadDto } from '@/open-api/Api'

export const useUploadFile = () => {
  return useMutation({
    mutationFn: async (file: File) => {
      const { data } = await WBDApi.storage.storageControllerUpload({
        contentType: file.type as UploadDto['contentType']
      })

      await fetch(data.url, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file
      })

      return data.url.split('?')[0]
    }
  })
}
